import type { UserProfile } from '@factoryfixinc/ats-interfaces';

export const getUserName = (user?: UserProfile): string => {
  return `${user?.nameFirst || ''} ${user?.nameLast || ''}`.trim();
};
